/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Step_Length_One_LinerInputs */

const en_exp_step_length_one_liner = /** @type {(inputs: Exp_Step_Length_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How far you travel with each step — your speed divided by your cadence, which sits next to it in steps per minute (spm).`)
};

const de_exp_step_length_one_liner = /** @type {(inputs: Exp_Step_Length_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie weit du mit jedem Schritt kommst — dein Tempo geteilt durch deine Kadenz, die daneben in Schritten pro Minute (spm) steht.`)
};

/**
* | output |
* | --- |
* | "How far you travel with each step — your speed divided by your cadence, which sits next to it in steps per minute (spm)." |
*
* @param {Exp_Step_Length_One_LinerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_step_length_one_liner = /** @type {((inputs?: Exp_Step_Length_One_LinerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Step_Length_One_LinerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_step_length_one_liner(inputs)
	return de_exp_step_length_one_liner(inputs)
});